<template>
  <li class="infinite-list-item" v-on:click="selectedItem">
    <ResaltarTexto :texto="label" :busqueda="$parent.text" />
  </li>
</template>

<script>
import ResaltarTexto from "@/components/ResaltarTexto.vue";

export default {
  components: { ResaltarTexto },
  props: {
    label: {
      required: true,
      default: () => "",
    },
    value: {
      required: true,
      default: () => {},
    },
    item: {
      required: false,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    selectedItem() {
      this.$parent.selected(this.value, this.label, this.item);
      this.$parent.clickToggle();
    },
  },
  watch: {},
};
</script>

